var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10348_42587)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.26562,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.76562,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0538 14.9277H32.6317C33.3543 14.9277 33.9399 15.3904 33.9399 15.9611V26.219H17.1208C17.0581 26.219 16.9957 26.2197 16.9334 26.2211V15.9611C16.9334 15.3904 17.5191 14.9277 18.2416 14.9277H22.821V20.0947C22.821 20.2317 22.8899 20.3632 23.0126 20.46C23.1353 20.557 23.3016 20.6114 23.4751 20.6114H27.3997C27.5732 20.6114 27.7395 20.557 27.8622 20.46C27.9849 20.3632 28.0538 20.2317 28.0538 20.0947V14.9277ZM17.1208 28.3616H33.9786C36.5951 28.3616 38.7165 30.2402 38.7165 32.5576C38.7165 34.875 36.5951 36.7535 33.9786 36.7535H17.1208C14.5041 36.7535 12.3828 34.875 12.3828 32.5576C12.3828 30.2402 14.5041 28.3616 17.1208 28.3616ZM20.531 32.5435C20.531 33.3719 19.7727 34.0435 18.8372 34.0435C17.9018 34.0435 17.1434 33.3719 17.1434 32.5435C17.1434 31.715 17.9018 31.0435 18.8372 31.0435C19.7727 31.0435 20.531 31.715 20.531 32.5435ZM27.2524 32.5435C27.2524 33.3719 26.4941 34.0435 25.5586 34.0435C24.6232 34.0435 23.8649 33.3719 23.8649 32.5435C23.8649 31.715 24.6232 31.0435 25.5586 31.0435C26.4941 31.0435 27.2524 31.715 27.2524 32.5435ZM32.28 34.0435C33.2155 34.0435 33.9738 33.3719 33.9738 32.5435C33.9738 31.715 33.2155 31.0435 32.28 31.0435C31.3446 31.0435 30.5863 31.715 30.5863 32.5435C30.5863 33.3719 31.3446 34.0435 32.28 34.0435Z",
    fill: "#06513D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10348_42587",
    x: 0.0656252,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10348_42587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10348_42587",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct44);
export default __webpack_public_path__ + "static/media/Product44.ab6635f7167dddd9aa459c3009876559.svg";
export { ForwardRef as ReactComponent };